import React from 'react';
import Spacing from '../Spacing';

export default function Section({
  topMd = '_',
  topLg = '_',
  topXl = '_',
  bottomMd = '_',
  bottomLg = '_',
  bottomXl = '_',
  topSm = '_',
  bottomSm = '_',
  children,
  ...props
}) {
  return (
    <section {...props}>
      <Spacing md={topMd} lg={topLg} xl={topXl} sm={topSm} />
      {children}
      <Spacing md={bottomMd} lg={bottomLg} xl={bottomXl} sm={bottomSm} />
    </section>
  );
}
